import { render, staticRenderFns } from "./InputMentionable.vue?vue&type=template&id=17ddeca0&"
import script from "./InputMentionable.vue?vue&type=script&lang=ts&"
export * from "./InputMentionable.vue?vue&type=script&lang=ts&"
import style0 from "./InputMentionable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports